/*
 * View for an tenant item
 */

define([
  "marionette",
  "modules/accountAdmin/tenantAdmin/tenantAdminModal/template/tenantAdminModalTemplate.html",
], function (Marionette, TenantAdminModalTemplate) {
  const TenantAdminModalView = {};

  TenantAdminModalView.tenantAdminModalView = Marionette.ItemView.extend({
    template: TenantAdminModalTemplate,
    isAllowedRoleEngine: function () {
      return this.$el.find("#allowedRoleEngine").prop("checked");
    },
    isAllowedRoleFordApi: function () {
      return this.$el.find("#allowedRoleFordApi").prop("checked");
    },
    isAllowedRoleTopicExportApi: function () {
      return this.$el.find("#allowedRoleTopicExportApi").prop("checked");
    },
    isAllowedRoleTopicSearchApi: function () {
      return this.$el.find("#allowedRoleTopicSearchApi").prop("checked");
    },
    isAllowedRoleTopicPublishApi: function () {
      return this.$el.find("#allowedRoleTopicPublishApi").prop("checked");
    },
    getAnalyticsTagSessionAttribute: function () {
      return this.$el.find("#analyticsTagSessionAttribute").val().trim();
    },
    getAuthenticationMethod: function () {
      return this.$el.find("#authenticationMethod").val();
    },
    getEmplifiSuiteAccountId: function () {
      return this.$el.find("#tenantEmplifiSuiteAccountId").val().trim();
    },
    getTenantName: function () {
      return this.$el.find("#tenantName").val().trim();
    },
    getTenantDescription: function () {
      return this.$el.find("#tenantDescription").val().trim();
    },
    getLandlordId: function () {
      return parseInt(this.$el.find("#landlord").val(), 10);
    },
    getLoginLockAttempts: function () {
      return parseInt(this.$el.find("#loginLockAttempts").val(), 10);
    },
    getLoginRetryTimeoutMinutes: function () {
      return parseInt(this.$el.find("#loginRetryTimeoutMinutes").val(), 10);
    },
    getPasswordComplexity: function () {
      return parseInt(this.$el.find("#passwordComplexity").val(), 10);
    },
    getPasswordHistoryCount: function () {
      return parseInt(this.$el.find("#passwordHistoryCount").val(), 10);
    },
    getPasswordMaxAge: function () {
      return parseInt(this.$el.find("#passwordMaxAge").val(), 10);
    },
    getPasswordMinAge: function () {
      return parseInt(this.$el.find("#passwordMinAge").val(), 10);
    },
    getPasswordMinLength: function () {
      return parseInt(this.$el.find("#passwordMinLength").val(), 10);
    },
    getSiteMapS3BucketName: function () {
      return this.$el.find("#siteMapS3BucketName").val();
    },
    getSiteMapCloudFront: function () {
      return this.$el.find("#siteMapCloudFront").val();
    },
    getSiteMapBaseUrl: function () {
      return this.$el.find("#siteMapBaseUrl").val();
    },
    getTableauUser: function () {
      return this.$el.find("#tableauUser").val();
    },
    tenantNameError: function (errorMessage) {
      this.$el
        .find("#tenantNameError")
        .append('<h5 class="error-message">' + errorMessage + "</h5>")
        .hide()
        .fadeIn();
    },
    tenantDescriptionError: function (errorMessage) {
      this.$el
        .find("#tenantDescriptionError")
        .append('<h5 class="error-message">' + errorMessage + "</h5>")
        .hide()
        .fadeIn();
    },
    landlordError: function (errorMessage) {
      this.$el
        .find("#landlordError")
        .append('<h5 class="error-message">' + errorMessage + "</h5>")
        .hide()
        .fadeIn();
    },
    analyticsTagSessionAttributeError: function (errorMessage) {
      this.$el
        .find("#analyticsTagSessionAttributeError")
        .append('<h5 class="error-message">' + errorMessage + "</h5>")
        .hide()
        .fadeIn();
    },
    emplifiSuiteAccountIdError: function (errorMessage) {
      this.$el
        .find("#tenantEmplifiSuiteAccountIdError")
        .append('<h5 class="error-message">' + errorMessage + "</h5>")
        .hide()
        .fadeIn();
    },
    clearErrors: function () {
      this.$el.find("h5.error-message").remove();
    },
    triggers: {
      "click #doneButton": "done",
      "click #cancelButton": "cancel",
    },
  });

  return TenantAdminModalView;
});
